import {ServiceAppointmentComponent} from './service-appointment.component';
import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {ConfirmAppointmentComponent} from './confirm-appointment/confirm-appointment.component';
import { ServiceHistoryComponent } from '../shared/service-history/service-history.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';

const routes: Routes = [
    {
        path: '',
        component: ServiceAppointmentComponent,
        canDeactivate:[DeactivateGuard]
    },
    {
        path: 'confirm',
        component: ConfirmAppointmentComponent
    },
    {
        path: 'servicehistory',
        component: ServiceHistoryComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServiceAppointmentRoutingModule { }
